/**
 * BSF Product Logos for the Admin.
 */
import { createElement as el } from '@wordpress/element';

// Logo: Spectra.
export const SpectraLogo = el(
	'svg',
	{
		width: 145,
		height: 32,
		viewBox: '0 0 145 32',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'g',
		{
			clipPath: 'url(#clip_spec_ai_spectra_logo)',
		},
		el(
			'path',
			{
				fillRule: 'evenodd',
				clipRule: 'evenodd',
				d: 'M16.0347 32C24.8712 32 32.0347 24.8366 32.0347 16C32.0347 7.16343 24.8712 0 16.0347 0C7.1981 0 0.034668 7.16343 0.034668 16C0.034668 24.8366 7.1981 32 16.0347 32ZM20.9549 20.688C21.88 20.1032 22.4346 19.1247 22.4347 18.0775C22.4347 16.6224 21.3723 15.357 19.8655 15.0174L15.3508 13.8968C14.9252 13.8009 14.8232 13.2761 15.1853 13.0452L18.7026 10.8017C20.3398 9.75739 20.7655 7.66455 19.6534 6.12718C19.5144 5.93499 19.2358 5.88503 19.0311 6.01559L11.0854 11.3753C10.1779 11.9541 9.63467 12.9173 9.63467 13.9473C9.63467 15.3851 10.6843 16.6352 12.1731 16.9708L16.7614 18.108C17.1879 18.2042 17.2891 18.7307 16.9252 18.9607L13.382 21.2006C11.7402 22.2385 11.3053 24.3297 12.4106 25.8714C12.5488 26.0641 12.8271 26.1152 13.0324 25.9854L20.9549 20.688Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M46.1596 23.755C44.6665 23.755 43.3371 23.5107 42.1714 23.022C41.0057 22.5333 40.0649 21.8411 39.3491 20.9452L41.9873 18.7155C42.6009 19.3875 43.2962 19.8762 44.0734 20.1816C44.8506 20.4667 45.6379 20.6092 46.4357 20.6092C47.0693 20.6092 47.5809 20.4667 47.9695 20.1816C48.358 19.8965 48.5523 19.4995 48.5523 18.9904C48.5523 18.5425 48.3681 18.1862 48.0001 17.9214C47.6321 17.6771 46.7526 17.3717 45.3618 17.0052C43.2962 16.4758 41.834 15.7529 40.975 14.8367C40.2183 14.0222 39.84 13.0143 39.84 11.813C39.84 10.856 40.1263 10.0212 40.6989 9.30854C41.2715 8.57551 42.0283 8.00536 42.969 7.59814C43.9098 7.19092 44.9323 6.9873 46.0367 6.9873C47.3048 6.9873 48.5011 7.2113 49.6262 7.65926C50.7507 8.10717 51.6915 8.71805 52.4481 9.49176L50.1779 11.9657C49.6056 11.4363 48.9409 10.9985 48.1843 10.6524C47.4479 10.2859 46.7626 10.1026 46.1286 10.1026C44.6563 10.1026 43.92 10.6117 43.92 11.6297C43.9404 12.1184 44.1654 12.5053 44.5949 12.7903C45.0039 13.0754 45.9343 13.4114 47.3866 13.7982C49.3295 14.3073 50.6995 14.9792 51.4972 15.814C52.1925 16.5267 52.5404 17.4735 52.5404 18.6545C52.5404 19.6318 52.2538 20.5074 51.6815 21.2811C51.1292 22.0548 50.3722 22.6657 49.4113 23.1137C48.4499 23.5412 47.366 23.755 46.1596 23.755Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M54.6069 28.8V7.32324H58.1987L58.7176 9.27794C59.2497 8.62637 59.9756 8.0868 60.8958 7.65924C61.8161 7.23163 62.7875 7.01782 63.8101 7.01782C65.2213 7.01782 66.4789 7.37417 67.5834 8.0868C68.6878 8.79944 69.5569 9.78701 70.1909 11.0494C70.825 12.3118 71.1418 13.7473 71.1418 15.3559C71.1418 16.9644 70.825 18.3999 70.1909 19.6623C69.5569 20.9247 68.6878 21.9225 67.5834 22.6555C66.4789 23.3681 65.2213 23.7245 63.8101 23.7245C62.8488 23.7245 61.9185 23.531 61.0184 23.1442C60.1187 22.737 59.3928 22.2279 58.8405 21.617V26.9766L54.6069 28.8ZM62.8899 20.1205C64.1374 20.1205 65.1496 19.6827 65.9267 18.8072C66.7039 17.9113 67.0924 16.7608 67.0924 15.3559C67.0924 13.9713 66.7039 12.8412 65.9267 11.9657C65.1496 11.0698 64.1374 10.6218 62.8899 10.6218C61.6424 10.6218 60.6298 11.0596 59.8527 11.9351C59.0755 12.8107 58.6869 13.9509 58.6869 15.3559C58.6869 16.7608 59.0755 17.9113 59.8527 18.8072C60.6298 19.6827 61.6424 20.1205 62.8899 20.1205Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M81.5247 23.7551C79.7862 23.7551 78.263 23.3987 76.9538 22.6861C75.645 21.9734 74.6223 20.9961 73.8863 19.754C73.1704 18.5119 72.8125 17.0867 72.8125 15.4781C72.8125 13.8084 73.1604 12.3424 73.8557 11.08C74.5711 9.7972 75.5426 8.78934 76.77 8.05631C78.0175 7.32328 79.4488 6.95679 81.0648 6.95679C82.5167 6.95679 83.8155 7.31313 84.9606 8.02577C86.1263 8.71807 87.0264 9.66486 87.66 10.8662C88.3147 12.0675 88.6214 13.442 88.5807 14.9894L88.5496 16.3027H76.8925C77.1174 17.4633 77.6696 18.3796 78.5492 19.0516C79.4488 19.7235 80.5839 20.0594 81.9544 20.0594C82.6904 20.0594 83.3551 19.9475 83.9485 19.7235C84.562 19.4995 85.2162 19.1024 85.9115 18.5323L87.9362 21.3422C87.0571 22.116 86.0445 22.7166 84.8994 23.1442C83.7743 23.5514 82.6498 23.7551 81.5247 23.7551ZM81.0955 10.5608C78.7842 10.5608 77.3935 11.5992 76.9231 13.6761H84.5926V13.5539C84.5314 12.6784 84.1629 11.9657 83.4882 11.4159C82.8335 10.8458 82.0363 10.5608 81.0955 10.5608Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M98.2424 23.755C96.7083 23.755 95.3281 23.3885 94.1007 22.6555C92.8943 21.9225 91.9329 20.9248 91.2171 19.6624C90.5217 18.4 90.1743 16.9644 90.1743 15.3559C90.1743 13.7677 90.5217 12.3424 91.2171 11.08C91.9329 9.81757 92.8943 8.81985 94.1007 8.08682C95.3281 7.3538 96.7083 6.9873 98.2424 6.9873C99.6943 6.9873 101.014 7.25199 102.199 7.78141C103.406 8.31082 104.347 9.054 105.022 10.011L102.721 12.7598C102.292 12.1693 101.698 11.6705 100.942 11.2632C100.185 10.8356 99.4182 10.6218 98.6411 10.6218C97.7821 10.6218 97.0155 10.8356 96.3403 11.2632C95.6861 11.6705 95.1645 12.2304 94.7759 12.9431C94.4079 13.6557 94.2237 14.46 94.2237 15.3559C94.2237 16.2518 94.418 17.0561 94.8066 17.7687C95.1951 18.4814 95.7268 19.0515 96.4015 19.4791C97.0767 19.8863 97.8333 20.0899 98.6717 20.0899C99.4694 20.0899 100.206 19.9169 100.881 19.5707C101.555 19.2042 102.169 18.6952 102.721 18.0436L105.022 20.7924C104.327 21.6883 103.365 22.4112 102.138 22.9609C100.911 23.4903 99.6125 23.755 98.2424 23.755Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M110.652 23.4495C108.632 23.4495 106.995 21.8122 106.995 19.7924V11.0799V7.32315V5.02336L111.167 3.19995V7.32315H114.32V11.0799H111.167V18.7428C111.167 19.2478 111.576 19.6571 112.081 19.6571H114.32V23.4495H110.652Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M116.769 23.4496V7.32326H120.36L120.879 9.98045C121.411 9.10493 122.107 8.39224 122.966 7.84248C123.845 7.27238 124.765 6.9873 125.726 6.9873C126.094 6.9873 126.432 7.01784 126.739 7.07892C127.066 7.11965 127.342 7.18072 127.567 7.26218L126.432 11.8435C126.207 11.7213 125.921 11.6195 125.573 11.5381C125.225 11.4567 124.878 11.4159 124.53 11.4159C123.528 11.4159 122.679 11.7621 121.984 12.4544C121.309 13.1263 120.972 13.9815 120.972 15.0199V23.4496H116.769Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M135.074 23.755C133.724 23.755 132.507 23.3885 131.424 22.6555C130.34 21.9225 129.47 20.9248 128.816 19.6624C128.182 18.4 127.865 16.9644 127.865 15.3559C127.865 13.7066 128.182 12.261 128.816 11.0189C129.47 9.75649 130.35 8.76893 131.454 8.05629C132.579 7.34365 133.847 6.9873 135.258 6.9873C136.403 6.9873 137.405 7.22145 138.264 7.6898C139.123 8.13775 139.809 8.7282 140.32 9.46122V7.32326H144.492V23.4496H140.747L140.289 21.2811C139.717 21.9938 138.97 22.5842 138.05 23.0525C137.15 23.5209 136.158 23.755 135.074 23.755ZM136.209 20.1205C137.457 20.1205 138.469 19.6827 139.246 18.8072C140.023 17.9316 140.412 16.7812 140.412 15.3559C140.412 13.9306 140.023 12.7802 139.246 11.9046C138.469 11.0291 137.457 10.5913 136.209 10.5913C134.982 10.5913 133.98 11.0291 133.203 11.9046C132.446 12.7802 132.068 13.9306 132.068 15.3559C132.068 16.7812 132.446 17.9316 133.203 18.8072C133.98 19.6827 134.982 20.1205 136.209 20.1205Z',
				fill: 'currentColor',
			},
		),
	),
	el(
		'defs',
		null,
		el(
			'clipPath',
			{
				id: 'clip_spec_ai_spectra_logo',
			},
			el(
				'rect',
				{
					width: 144.457,
					height: 32,
					fill: 'white',
					transform: 'translate(0.034668)',
				},
			),
		),
	),
);

// Logo: Astra.
export const AstraLogo = el(
	'svg',
	{
		width: 124,
		height: 36,
		viewBox: '0 0 124 36',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'g',
		{ clipPath: 'url(#clip_spec_ai_astra_logo)' },
		el(
			'mask',
			{
				id: 'mask_spec_ai_astra_logo',
				style: { maskType: 'luminance' },
				maskUnits: 'userSpaceOnUse',
				x: 0,
				y: 0,
				width: 123,
				height: 36,
			},
			el(
				'path',
				{
					d: 'M122.605 0H0.277344V35.2471H122.605V0Z',
					fill: 'white',
				},
			),
		),
		el(
			'g',
			{ mask: 'url(#mask_spec_ai_astra_logo)' },
			el(
				'path',
				{
					d: 'M51.2049 23.3476H43.5876L41.8462 26.7455H37.7261L47.1131 8.40283H48.1891L56.8965 26.7455H52.8189L51.2049 23.3476ZM49.4775 19.6819L47.552 15.5932L45.4707 19.6819H49.4775Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M63.5369 18.9769C62.928 18.8218 61.7953 18.5256 60.7476 17.8207C59.2751 16.8479 58.4539 15.4381 58.3832 13.6898C58.2982 12.2235 58.7797 10.9405 59.7283 9.95356C61.1016 8.54369 63.0696 8.14893 64.0182 8.14893C66.6942 8.14893 68.1949 9.12174 69.54 9.98179L70.1487 10.3766L68.2232 13.4924L67.572 13.0695C66.3827 12.3081 65.6323 11.8147 64.0182 11.8147C63.7775 11.8147 62.8572 11.9979 62.39 12.4914C62.2342 12.6465 62.0502 12.9425 62.0785 13.5347C62.1068 14.4793 62.7581 15.0009 64.4429 15.4239C64.6553 15.4803 64.8111 15.5227 64.9668 15.579C66.7225 16.1853 68.0958 16.9889 69.0444 18.0181C69.993 19.0615 70.4886 20.3021 70.4886 21.5992C70.4886 22.8822 69.9364 24.2216 69.0161 25.2367C67.94 26.4351 66.4393 27.1259 64.7828 27.1259C63.9616 27.1259 62.8572 27.0696 61.5547 26.6748C59.8981 26.1532 58.4256 25.2367 57.1655 23.8973L59.8415 21.3877C61.7812 23.4603 63.9616 23.4603 64.7828 23.4603C66.3119 23.4603 66.8074 22.0785 66.8074 21.5992C66.8074 20.5982 65.6747 19.6818 63.7634 19.0332L63.6784 19.005L63.5369 18.9769Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M86.3605 8.40277V12.0685H81.2635V26.7595H77.5823V12.0544H72.457V8.38867H86.3605V8.40277Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M98.0829 26.7453L94.6428 19.3857H92.8023V26.7171H89.1211V8.37451H96.0584C99.1023 8.37451 101.581 10.8559 101.581 13.9012C101.581 16.1289 100.264 18.0322 98.352 18.9064L102.005 26.7594H98.0829V26.7453ZM92.8023 12.0402V15.7341H96.0584C97.0778 15.7341 97.8991 14.9163 97.8991 13.9012C97.8991 12.8861 97.0778 12.0402 96.0584 12.0402H92.8023Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M116.928 23.3476H109.311L107.569 26.7455H103.449L112.836 8.40283H113.912L122.605 26.7455H118.528L116.928 23.3476ZM115.187 19.6819L113.261 15.5932L111.179 19.6819H115.187Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M17.8337 35.1063C27.5298 35.1063 35.39 27.279 35.39 17.6237C35.39 7.96833 27.5298 0.141113 17.8337 0.141113C8.1376 0.141113 0.277344 7.96833 0.277344 17.6237C0.277344 27.279 8.1376 35.1063 17.8337 35.1063ZM17.6213 7.89556C16.1348 11.0183 14.6483 14.1445 13.1617 17.2706C11.675 20.3973 10.1882 23.5239 8.70154 26.647H12.5243C13.7278 24.229 14.9312 21.8076 16.1347 19.3861C17.3381 16.9646 18.5416 14.5432 19.7451 12.1252L17.6213 7.89556ZM19.745 19.4564C20.3573 18.1876 20.9696 16.9188 21.5855 15.65C22.4844 17.4826 23.3799 19.3154 24.2753 21.1481C25.171 22.9811 26.0665 24.814 26.9657 26.647H22.8597C22.6261 26.1043 22.3889 25.5649 22.1518 25.0257C21.9147 24.4864 21.6774 23.9471 21.4438 23.4043H17.9043H17.8335L17.9043 23.2633C18.5202 21.9943 19.1326 20.7254 19.745 19.4564Z',
					fill: 'currentColor',
					fillRule: 'evenodd',
					clipRule: 'evenodd',
				},
			),
		),
	),
	el(
		'defs',
		null,
		el(
			'clipPath',
			{
				id: 'clip_spec_ai_astra_logo',
			},
			el(
				'rect',
				{
					width: 123.158,
					height: 36,
					fill: 'white',
					transform: 'translate(0.277344)',
				},
			),
		),
	),
);

// Logo: CartFlows.
export const CartFlowsLogo = el(
	'svg',
	{
		width: 171,
		height: 32,
		viewBox: '0 0 171 32',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'g',
		{
			clipPath: 'url(#clip_spec_ai_cartflows_logo)',
		},
		el(
			'mask',
			{
				id: 'mask_spec_ai_cartflows_logo',
				style: { maskType: 'luminance' },
				maskUnits: 'userSpaceOnUse',
				x: 0,
				y: 0,
				width: 171,
				height: 32,
			},
			el(
				'path',
				{
					d: 'M170.202 0H0.647949V31.3308H170.202V0Z',
					fill: 'white',
				},
			)
		),
		el(
			'g',
			{
				mask: 'url(#mask_spec_ai_cartflows_logo)',
			},
			el(
				'path',
				{
					d: 'M19.8602 2.03637C18.7416 3.13295 18.0352 4.64074 18.0352 6.34436V16.331C18.0352 17.7997 16.8381 18.9942 15.3662 18.9942H8.6547C7.18288 18.9942 5.98578 17.7997 5.98578 16.331C5.98578 14.8624 7.18288 13.668 8.6547 13.668H16.0139V8.34169H8.6547C8.20334 8.34169 7.75198 8.38086 7.32024 8.43957C3.53274 9.0858 0.647949 12.3756 0.647949 16.331C0.647949 19.8166 2.88513 22.7735 5.98578 23.87C6.41752 24.0267 6.86888 24.1442 7.32024 24.2225C7.75198 24.3008 8.20334 24.34 8.6547 24.34H15.3662C15.8176 24.34 16.269 24.3008 16.7007 24.2225C17.1521 24.1442 17.6034 24.0267 18.0352 23.87C21.1554 22.7735 23.373 19.8166 23.373 16.331V13.668C26.3167 13.668 28.7108 11.279 28.7108 8.34169H23.373V6.34436C23.373 5.9723 23.6674 5.67858 24.0402 5.67858H25.3747C27.0035 5.67858 28.4754 5.03238 29.5743 3.97497C30.5359 3.03504 31.2031 1.76223 31.3602 0.332764H24.0402C22.4311 0.352345 20.9396 0.998546 19.8602 2.03637Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M8.65476 25.6521C7.18293 25.6521 5.98584 26.8466 5.98584 28.3153C5.98584 29.7839 7.18293 30.9783 8.65476 30.9783C10.1266 30.9783 11.3237 29.7839 11.3237 28.3153C11.3237 26.8466 10.1266 25.6521 8.65476 25.6521Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M16.6616 25.6521C15.1898 25.6521 13.9927 26.8466 13.9927 28.3153C13.9927 29.7839 15.1898 30.9783 16.6616 30.9783C18.1335 30.9783 19.3305 29.7839 19.3305 28.3153C19.3305 26.8466 18.1531 25.6521 16.6616 25.6521Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M45.9215 27.2382C44.3908 27.2382 43.0171 27.0032 41.82 26.5333C40.6033 26.0633 39.5828 25.378 38.739 24.4772C37.8951 23.5568 37.2476 22.4603 36.7962 21.1483C36.3448 19.8363 36.1289 18.3481 36.1289 16.6445C36.1289 14.9605 36.3841 13.4527 36.9139 12.1407C37.4241 10.8288 38.1306 9.73217 39.0333 8.81183C39.9361 7.91104 40.9958 7.2061 42.1929 6.75572C43.4096 6.28576 44.7048 6.05078 46.0982 6.05078C46.942 6.05078 47.7073 6.10953 48.3942 6.2466C49.0811 6.38367 49.6698 6.52074 50.18 6.67739C50.6903 6.83405 51.1024 6.99071 51.4359 7.16694C51.7696 7.34318 52.0051 7.46067 52.1425 7.53899L51.0435 10.5742C50.5725 10.2805 49.9052 10.0063 49.0418 9.73217C48.1783 9.4776 47.2364 9.34051 46.2159 9.34051C45.3328 9.34051 44.5085 9.49714 43.7432 9.79087C42.9778 10.1042 42.3303 10.5546 41.7612 11.1616C41.2117 11.7686 40.7603 12.5323 40.4659 13.4331C40.152 14.3535 39.9949 15.4108 39.9949 16.6249C39.9949 17.7019 40.1127 18.681 40.3482 19.5818C40.5836 20.4825 40.9761 21.2658 41.4864 21.912C41.9966 22.5582 42.6443 23.0673 43.4096 23.4394C44.1946 23.8114 45.1366 23.9877 46.2159 23.9877C47.5308 23.9877 48.5905 23.8506 49.4146 23.596C50.2389 23.3414 50.8668 23.0869 51.3182 22.8519L52.3191 25.8675C52.0836 26.0241 51.7696 26.2004 51.3575 26.3375C50.9649 26.4941 50.494 26.6507 49.9445 26.7878C49.395 26.9249 48.7867 27.0424 48.0999 27.1403C47.4326 27.199 46.7065 27.2382 45.9215 27.2382Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M60.5224 11.1226C61.6998 11.1226 62.681 11.2597 63.4857 11.5729C64.2903 11.8666 64.9379 12.2779 65.4089 12.8066C65.8798 13.3353 66.2331 13.9815 66.4293 14.7256C66.6452 15.4697 66.7433 16.2922 66.7433 17.1929V26.4746C66.1938 26.5921 65.3696 26.7292 64.2707 26.9055C63.1716 27.0621 61.9157 27.16 60.542 27.16C59.6196 27.16 58.7758 27.0621 58.0105 26.8858C57.2451 26.7096 56.5975 26.4355 56.0676 26.0438C55.5182 25.6522 55.106 25.1431 54.8116 24.536C54.5173 23.9094 54.3604 23.1457 54.3604 22.2254C54.3604 21.3442 54.5369 20.6001 54.8706 19.9931C55.2238 19.3861 55.6751 18.8965 56.2638 18.5245C56.8526 18.1328 57.5198 17.8783 58.3048 17.702C59.0702 17.5258 59.8748 17.4474 60.7186 17.4474C61.1111 17.4474 61.5232 17.4671 61.955 17.5258C62.3867 17.5845 62.8381 17.6629 63.3287 17.7803V17.1929C63.3287 16.7817 63.2894 16.3901 63.1913 16.018C63.0931 15.6459 62.9166 15.3327 62.681 15.0389C62.4456 14.7647 62.1119 14.5298 61.7194 14.3732C61.327 14.2165 60.8168 14.1381 60.2083 14.1381C59.3842 14.1381 58.6384 14.1969 57.9516 14.3144C57.2647 14.4319 56.7152 14.569 56.2835 14.7256L55.8518 11.8666C56.3031 11.71 56.9508 11.5534 57.8142 11.3967C58.6188 11.2009 59.5412 11.1226 60.5224 11.1226ZM60.8168 24.3206C61.9157 24.3206 62.7399 24.2619 63.3091 24.1445V20.2085C63.1128 20.1498 62.8381 20.091 62.4652 20.0323C62.0923 19.9735 61.6802 19.9343 61.2288 19.9343C60.8364 19.9343 60.4439 19.9735 60.0514 20.0323C59.6393 20.091 59.2861 20.2085 58.9721 20.3652C58.658 20.5218 58.3833 20.7372 58.187 21.0309C57.9908 21.305 57.8927 21.6771 57.8927 22.0884C57.8927 22.9304 58.1478 23.5178 58.6777 23.8311C59.2075 24.164 59.914 24.3206 60.8168 24.3206Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M79.8126 14.6862C79.5182 14.5884 79.106 14.4905 78.5958 14.373C78.0856 14.2555 77.4772 14.2164 76.7904 14.2164C76.3979 14.2164 75.9858 14.2555 75.5344 14.3338C75.1027 14.4121 74.7887 14.4708 74.6121 14.5296V26.7878H71.0601V12.2386C71.747 11.984 72.6104 11.749 73.6308 11.514C74.6513 11.2986 75.7896 11.1812 77.0455 11.1812C77.281 11.1812 77.5557 11.2007 77.8697 11.2203C78.1838 11.2398 78.4977 11.2986 78.8117 11.3378C79.1257 11.3966 79.4201 11.4553 79.7145 11.514C80.0088 11.5728 80.2443 11.6511 80.4209 11.7098L79.8126 14.6862Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M82.7168 7.46074L86.2688 6.87329V11.4946H91.7248V14.4514H86.2688V20.6784C86.2688 21.9121 86.465 22.7737 86.8574 23.3023C87.2498 23.8311 87.9176 24.0857 88.8397 24.0857C89.4873 24.0857 90.0566 24.0073 90.5669 23.8898C91.057 23.7528 91.4696 23.6352 91.7635 23.4982L92.3522 26.2984C91.9404 26.4746 91.4107 26.6509 90.7429 26.8467C90.076 27.0229 89.2911 27.1208 88.3884 27.1208C87.2894 27.1208 86.3867 26.9641 85.6406 26.69C84.9147 26.3963 84.326 25.9655 83.8942 25.4172C83.4625 24.8689 83.1682 24.1835 82.9915 23.4003C82.8149 22.617 82.7364 21.7162 82.7364 20.698L82.7168 7.46074Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M95.335 26.8075V6.52075H108.189V9.65386H99.0444V14.8234H107.169V17.9565H99.0444V26.8075H95.335Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M116.648 27.101C115.608 27.0815 114.726 26.964 114.019 26.7486C113.332 26.5332 112.782 26.2198 112.37 25.8283C111.958 25.4171 111.664 24.9275 111.507 24.34C111.33 23.733 111.252 23.0673 111.252 22.3036V4.67998L114.804 4.09253V21.6182C114.804 22.049 114.823 22.4015 114.902 22.6952C114.981 22.9889 115.098 23.2434 115.275 23.4393C115.452 23.6351 115.686 23.7917 115.981 23.9093C116.295 24.0071 116.668 24.1051 117.139 24.1638L116.648 27.101Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M133.898 19.1315C133.898 20.3455 133.721 21.4421 133.368 22.4408C133.034 23.4394 132.524 24.2815 131.876 24.9865C131.228 25.6718 130.463 26.2201 129.561 26.6313C128.638 27.0229 127.637 27.2187 126.558 27.2187C125.459 27.2187 124.458 27.0229 123.556 26.6313C122.653 26.2397 121.887 25.6914 121.24 24.9865C120.592 24.2815 120.101 23.4394 119.728 22.4408C119.356 21.4421 119.179 20.3455 119.179 19.1315C119.179 17.9174 119.356 16.8208 119.728 15.8418C120.082 14.8627 120.592 14.0207 121.259 13.3157C121.907 12.6108 122.692 12.0821 123.594 11.6905C124.497 11.3183 125.478 11.1226 126.558 11.1226C127.637 11.1226 128.618 11.3183 129.54 11.6905C130.443 12.0821 131.228 12.6108 131.876 13.3157C132.524 14.0207 133.014 14.8627 133.387 15.8418C133.721 16.8208 133.898 17.9174 133.898 19.1315ZM130.267 19.1315C130.267 17.6042 129.933 16.4096 129.285 15.5088C128.638 14.6081 127.716 14.1773 126.538 14.1773C125.361 14.1773 124.438 14.6081 123.791 15.5088C123.143 16.39 122.81 17.6042 122.81 19.1315C122.81 20.6784 123.143 21.8925 123.791 22.7933C124.438 23.694 125.361 24.1445 126.538 24.1445C127.716 24.1445 128.618 23.694 129.285 22.7933C129.933 21.8925 130.267 20.6784 130.267 19.1315Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M146.399 17.1731C145.947 18.8767 145.456 20.5607 144.946 22.1861C144.436 23.8114 143.925 25.3583 143.415 26.8073H140.491C140.099 25.9066 139.687 24.8883 139.255 23.733C138.823 22.5777 138.391 21.3636 137.96 20.0516C137.528 18.7397 137.096 17.3689 136.665 15.9199C136.233 14.4708 135.821 13.0022 135.408 11.4944H139.156C139.333 12.3169 139.549 13.1981 139.785 14.1379C140.02 15.0974 140.255 16.057 140.511 17.036C140.766 18.0151 141.041 18.9746 141.295 19.9146C141.571 20.8545 141.845 21.7161 142.12 22.4994C142.415 21.5986 142.708 20.6782 142.984 19.6992C143.258 18.7592 143.533 17.7997 143.788 16.8402C144.043 15.8807 144.279 14.9408 144.514 14.0401C144.75 13.1393 144.946 12.2777 145.123 11.4749H147.85C148.027 12.2777 148.223 13.1197 148.439 14.0401C148.655 14.9408 148.89 15.8807 149.126 16.8402C149.381 17.7997 149.636 18.7592 149.911 19.6992C150.205 20.6587 150.48 21.579 150.774 22.4994C151.029 21.7161 151.304 20.8545 151.579 19.9146C151.854 18.9746 152.128 18.0151 152.383 17.036C152.658 16.057 152.894 15.0779 153.149 14.1379C153.385 13.1981 153.581 12.3169 153.777 11.4944H157.447C157.034 13.0022 156.603 14.4708 156.191 15.9199C155.759 17.3689 155.327 18.7397 154.895 20.0516C154.463 21.3636 154.032 22.5777 153.6 23.733C153.168 24.8883 152.756 25.9066 152.345 26.8073H149.46C148.949 25.3583 148.439 23.8309 147.89 22.1861C147.34 20.5607 146.849 18.8963 146.399 17.1731Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M163.963 24.2617C164.904 24.2617 165.591 24.1442 166.003 23.9288C166.435 23.6939 166.651 23.3218 166.651 22.7735C166.651 22.2644 166.435 21.8532 165.964 21.5203C165.493 21.1873 164.747 20.8153 163.687 20.4237C163.04 20.1887 162.451 19.9341 161.921 19.6795C161.372 19.4054 160.921 19.1117 160.528 18.7592C160.135 18.4068 159.841 17.9956 159.606 17.4864C159.37 16.9968 159.272 16.3899 159.272 15.6458C159.272 14.2358 159.782 13.1392 160.822 12.3168C161.843 11.514 163.256 11.1028 165.041 11.1028C165.944 11.1028 166.808 11.1811 167.632 11.3574C168.456 11.5336 169.065 11.6902 169.477 11.8469L168.829 14.7058C168.437 14.5296 167.946 14.3729 167.338 14.2163C166.729 14.0792 166.023 14.0009 165.238 14.0009C164.512 14.0009 163.923 14.1184 163.472 14.3729C163.02 14.6079 162.805 14.9799 162.805 15.5087C162.805 15.7632 162.843 15.9787 162.942 16.1744C163.02 16.3702 163.177 16.5465 163.393 16.7227C163.609 16.899 163.883 17.0556 164.237 17.2123C164.59 17.3885 165.022 17.5451 165.532 17.7214C166.376 18.0347 167.083 18.348 167.671 18.6417C168.26 18.9355 168.751 19.288 169.124 19.66C169.496 20.032 169.791 20.4824 169.968 20.972C170.144 21.4615 170.223 22.0294 170.223 22.7147C170.223 24.1834 169.673 25.2995 168.593 26.0437C167.494 26.8074 165.964 27.1794 163.942 27.1794C162.588 27.1794 161.51 27.0619 160.685 26.8465C159.861 26.6311 159.291 26.4549 158.958 26.3178L159.567 23.361C160.097 23.5764 160.724 23.7917 161.47 23.9876C162.177 24.1638 163.02 24.2617 163.963 24.2617Z',
					fill: 'currentColor',
				},
			),
		),
	),
	el(
		'defs',
		null,
		el(
			'clipPath',
			{
				id: 'clip_spec_ai_cartflows_logo',
			},
			el(
				'rect',
				{
					width: 170.105,
					height: 32,
					fill: 'white',
					transform: 'translate(0.435547)',
				},
			)
		)
	)
);

// Logo: Starter Templates.
export const StarterTemplatesLogo = el(
	'svg',
	{
		width: 99,
		height: 36,
		viewBox: '0 0 99 36',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'g',
		{
			clipPath: 'url(#clip_spec_ai_starter_templates_logo)',
		},
		el(
			'g',
			{
				opacity: 0.5,
			},
			el(
				'path',
				{
					d: 'M24.5032 2.20013L22.0791 2.95518L24.2648 5.29978L27.9208 6.37276L26.9273 3.39231C26.6094 2.43857 25.5761 1.84247 24.5032 2.20013Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M2.52714 11.4197L3.36166 13.8438L5.70626 11.6582L6.77923 7.9624L3.7988 8.95587C2.76557 9.31352 2.16948 10.4262 2.52714 11.4197Z',
					fill: 'currentColor',
				}
			),
			el(
				'path',
				{
					d: 'M8.3291 29.2627L9.32257 32.2431C9.60075 33.3161 10.7532 33.8327 11.7864 33.5546L14.3297 32.72L12.2235 30.4151L8.3291 29.2627Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M33.7224 24.1759L32.8879 21.6326L30.6624 23.7388L29.4702 27.6332L32.4508 26.6398C33.484 26.3616 34.1595 25.2489 33.7224 24.1759Z',
					fill: 'currentColor',
				},
			)
		),
		el(
			'g',
			{
				opacity: 0.8,
			},
			el(
				'path',
				{
					d: 'M20.1315 0.92843C19.3765 0.0939033 18.1843 0.0541644 17.3498 0.809211L15.2437 2.75643L19.2573 3.94861L24.2247 5.37925L22.0391 3.03461L20.1315 0.92843Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M1.33492 15.7114C0.500398 16.4664 0.460658 17.6586 1.21571 18.4931L3.04371 20.4801L4.15641 16.5856L5.62676 11.658L3.28214 13.8436L1.33492 15.7114Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M35.0341 17.0229L33.2061 15.0757L32.0139 19.0099L30.623 23.6991L32.8484 21.5929L34.8354 19.7252C35.7096 19.0894 35.7891 17.8574 35.0341 17.0229Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M12.144 30.3752L14.2502 32.6802L16.0783 34.6274C16.8333 35.4619 18.0652 35.5016 18.8599 34.7466L20.8469 32.9186L17.0319 31.8059L12.144 30.3752Z',
					fill: 'currentColor',
				},
			)
		),
		el(
			'path',
			{
				d: 'M33.1264 7.96245L27.8808 6.45234L24.2248 5.37941L19.3368 3.90903L15.3232 2.71686L10.8724 1.4452C9.75963 1.16703 8.5675 1.72338 8.28932 2.87581L6.73948 8.08164L5.70626 11.7774L4.23589 16.7051L3.12319 20.5995L1.73231 25.2491C1.45413 26.3617 2.01049 27.5539 3.16292 27.8321L8.40852 29.3422L12.2235 30.4549L17.0319 31.8855L20.8469 32.9982L25.4169 34.3493C26.5296 34.6275 27.7218 34.0712 28 32.9188L29.5101 27.7526L30.7023 23.8582L32.1328 19.1689L33.325 15.2348L34.6762 10.7045C34.8351 9.43276 34.239 8.24063 33.1264 7.96245ZM24.3837 9.47255V13.6054H18.8997H11.5479C11.5876 13.3272 11.7068 12.9696 11.8261 12.6517C12.0645 12.0556 12.4222 11.4595 12.9388 11.0224C13.4157 10.6249 14.0118 10.1481 14.568 9.90966C15.1642 9.63148 15.8795 9.51228 16.5551 9.51228H24.3837V9.47255ZM12.2235 26.322V22.1891H19.8137C19.9329 22.1891 20.0919 22.1891 20.2111 22.1494C20.3303 22.1097 20.4495 22.0301 20.5687 21.9109C20.6879 21.7917 20.7277 21.6725 20.8072 21.5533C20.8469 21.434 20.8469 21.3148 20.8469 21.1559C20.8469 21.0367 20.8469 20.8777 20.8072 20.7585C20.7674 20.6393 20.6879 20.52 20.5687 20.4008C20.4495 20.2817 20.3303 20.2419 20.2111 20.1624C20.0919 20.1227 19.9726 20.1227 19.8137 20.1227H16.6345C15.9987 20.1227 15.2039 20.0035 14.6476 19.7253C14.0515 19.4868 13.4554 19.1292 13.0183 18.6126C12.6208 18.2152 12.144 17.5396 11.9056 16.9833C11.7466 16.6256 11.6672 16.3474 11.6274 15.9898H16.6742H18.9792H19.8534C20.4893 15.9898 21.2841 16.1487 21.8404 16.3872C22.4365 16.6256 23.0326 16.9833 23.4697 17.4998C23.8671 17.8973 24.3439 18.5728 24.5824 19.1292C24.8606 19.7253 24.9798 20.4406 24.9798 21.1957C24.9798 21.8315 24.8208 22.6262 24.5824 23.1826C24.3439 23.7787 23.9863 24.3747 23.4697 24.8119C23.0723 25.2093 22.3967 25.6862 21.8404 25.9246C21.2045 26.2027 20.4893 26.322 19.7739 26.322H12.2235Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M43.4984 15.1948C41.9883 15.1948 40.7962 14.7576 39.9219 13.8436L40.9153 12.4528C41.6307 13.2078 42.5447 13.6053 43.6177 13.6053C44.0945 13.6053 44.4522 13.5258 44.6906 13.3271C44.9687 13.1284 45.088 12.9296 45.088 12.6515C45.088 12.4131 44.9687 12.2143 44.7304 12.0952C44.4919 11.9362 44.174 11.817 43.8164 11.7772C43.4587 11.6978 43.0613 11.6183 42.6242 11.4991C42.1871 11.3798 41.7897 11.2209 41.432 11.062C41.0743 10.903 40.7564 10.6645 40.518 10.3069C40.2795 9.94923 40.1603 9.55179 40.1603 9.03522C40.1603 8.31993 40.4385 7.68411 41.0346 7.20721C41.6307 6.69057 42.3857 6.45215 43.3792 6.45215C44.7304 6.45215 45.843 6.84956 46.6776 7.64431L45.6841 8.95576C45.0085 8.31993 44.174 8.04175 43.2203 8.04175C42.8229 8.04175 42.5447 8.12121 42.346 8.28014C42.1473 8.43913 42.0281 8.63778 42.0281 8.91596C42.0281 9.11468 42.1473 9.27361 42.3857 9.4326C42.6242 9.59158 42.9421 9.67105 43.2997 9.75051C43.6574 9.82997 44.0547 9.90943 44.4919 10.0684C44.9291 10.1876 45.2867 10.3466 45.6841 10.5056C46.0815 10.6645 46.3597 10.9427 46.5981 11.3003C46.8366 11.658 46.9558 12.0952 46.9558 12.572C46.9558 13.4065 46.6776 14.0424 46.0815 14.559C45.4456 14.9564 44.6112 15.1948 43.4984 15.1948Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M49.9762 15.1949C49.4198 15.1949 48.9828 15.0359 48.6647 14.7577C48.3467 14.4795 48.2275 14.0425 48.2275 13.5259V10.3069H47.1943V8.8763H48.2275V7.20728H49.8568V8.8763H51.0889V10.3069H49.8568V13.0887C49.8568 13.2874 49.8967 13.4463 50.0156 13.5656C50.1349 13.6848 50.2543 13.7643 50.4131 13.7643C50.6518 13.7643 50.8502 13.6848 50.9695 13.5656L51.3271 14.7975C51.0489 15.0757 50.572 15.1949 49.9762 15.1949Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M57.5262 15.0756H55.897V14.4398C55.4595 14.9563 54.7843 15.2345 53.9498 15.2345C53.3934 15.2345 52.9164 15.0358 52.4795 14.6782C52.042 14.3206 51.8037 13.804 51.8037 13.1681C51.8037 12.4926 52.0025 12.0157 52.4395 11.658C52.8765 11.3401 53.3535 11.1414 53.9498 11.1414C54.8238 11.1414 55.4595 11.3798 55.897 11.8964V11.0619C55.897 10.744 55.7777 10.5056 55.5395 10.3069C55.3007 10.1082 54.9831 10.0287 54.5456 10.0287C53.8704 10.0287 53.274 10.2671 52.7576 10.744L52.1613 9.67109C52.8765 9.0352 53.791 8.71729 54.8637 8.71729C55.6583 8.71729 56.2941 8.916 56.811 9.27365C57.3274 9.63129 57.5661 10.2274 57.5661 11.0619V15.0756H57.5262ZM54.6255 14.1218C55.2213 14.1218 55.6583 13.9629 55.9365 13.6052V12.8502C55.6583 12.4926 55.2213 12.3336 54.6255 12.3336C54.3074 12.3336 54.0292 12.413 53.791 12.572C53.5522 12.731 53.4728 12.9694 53.4728 13.2476C53.4728 13.5258 53.5922 13.7642 53.791 13.9231C54.0292 14.0424 54.3074 14.1218 54.6255 14.1218Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M60.7854 15.0757H59.1558V8.91607H60.7854V9.75061C61.0236 9.47243 61.3018 9.23398 61.6594 9.03526C62.017 8.83661 62.3751 8.75708 62.7327 8.75708V10.3466C62.6133 10.3069 62.4545 10.3069 62.2952 10.3069C62.017 10.3069 61.7389 10.3864 61.4212 10.5056C61.103 10.6248 60.9043 10.8235 60.7854 11.0223V15.0757Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M65.7926 15.1949C65.2362 15.1949 64.7988 15.0359 64.4811 14.7577C64.1629 14.4795 64.0436 14.0425 64.0436 13.5259V10.3069H63.0107V8.8763H64.0436V7.20728H65.6732V8.8763H66.905V10.3069H65.6732V13.0887C65.6732 13.2874 65.7127 13.4463 65.832 13.5656C65.9514 13.6848 66.0705 13.7643 66.2295 13.7643C66.4678 13.7643 66.6668 13.6848 66.7859 13.5656L67.1433 14.7975C66.8651 15.0757 66.4285 15.1949 65.7926 15.1949Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M65.7926 15.1949C65.2362 15.1949 64.7988 15.0359 64.4811 14.7577C64.1629 14.4795 64.0436 14.0425 64.0436 13.5259V10.3069H63.0107V8.8763H64.0436V7.20728H65.6732V8.8763H66.905V10.3069H65.6732V13.0887C65.6732 13.2874 65.7127 13.4463 65.832 13.5656C65.9514 13.6848 66.0705 13.7643 66.2295 13.7643C66.4678 13.7643 66.6668 13.6848 66.7859 13.5656L67.1433 14.7975C66.8651 15.0757 66.4285 15.1949 65.7926 15.1949Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M70.9587 15.1949C70.005 15.1949 69.2097 14.8769 68.6141 14.3207C68.0178 13.7643 67.6997 12.9297 67.6997 11.976C67.6997 11.062 68.0178 10.307 68.6141 9.67109C69.2097 9.03526 69.9651 8.75708 70.9188 8.75708C71.8325 8.75708 72.5879 9.07499 73.1442 9.71082C73.7006 10.3466 74.018 11.1415 74.018 12.1747V12.5323H69.4487C69.4879 12.9297 69.6869 13.2874 70.005 13.5656C70.3225 13.8438 70.7198 13.9629 71.2362 13.9629C71.5144 13.9629 71.7926 13.9232 72.1107 13.804C72.4288 13.6848 72.6671 13.5258 72.866 13.3668L73.5815 14.4001C72.866 14.9167 72.0315 15.1949 70.9587 15.1949ZM72.3489 11.3799C72.3097 11.0223 72.1905 10.7043 71.9523 10.4262C71.7134 10.148 71.3161 9.989 70.8396 9.989C70.3624 9.989 70.005 10.1083 69.7661 10.3864C69.5279 10.6646 69.3688 10.9825 69.3289 11.3402H72.3489V11.3799Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M76.7205 15.0757H75.0913V8.91607H76.7205V9.75061C76.9587 9.47243 77.2369 9.23398 77.5949 9.03526C77.9523 8.83661 78.3104 8.75708 78.6677 8.75708V10.3466C78.5486 10.3069 78.3896 10.3069 78.2305 10.3069C77.9523 10.3069 77.6741 10.3864 77.356 10.5056C77.0386 10.6248 76.8396 10.8235 76.7205 11.0223V15.0757Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M44.2535 28.0704H42.4255V21.1558H39.9219V19.5662H46.7173V21.1558H44.2535V28.0704Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M49.4989 28.2293C48.5452 28.2293 47.7504 27.9114 47.1542 27.355C46.5184 26.7589 46.2402 25.9642 46.2402 25.0104C46.2402 24.0964 46.5582 23.3413 47.1542 22.7055C47.7504 22.0697 48.5054 21.7915 49.459 21.7915C50.3734 21.7915 51.1281 22.1095 51.6844 22.7453C52.2408 23.3811 52.519 24.1759 52.519 25.2091V25.5667H47.9491C47.9888 25.9642 48.1875 26.3218 48.5054 26.6C48.8231 26.8782 49.2207 26.9974 49.7371 26.9974C50.0153 26.9974 50.2935 26.9576 50.6116 26.8384C50.9297 26.7192 51.168 26.5602 51.3668 26.4013L52.0819 27.4345C51.4062 27.9511 50.5717 28.2293 49.4989 28.2293ZM50.9297 24.4143C50.8898 24.0567 50.7704 23.7388 50.5322 23.4606C50.2935 23.1824 49.8964 23.0235 49.4195 23.0235C48.9425 23.0235 48.5849 23.1427 48.3464 23.4209C48.108 23.699 47.9491 24.017 47.9093 24.3745H50.9297V24.4143Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M62.9308 28.0705H61.3017V24.176C61.3017 23.5402 60.984 23.1825 60.3877 23.1825C60.1095 23.1825 59.8713 23.262 59.6725 23.3812C59.4338 23.5402 59.275 23.6992 59.1161 23.8978V28.0705H57.4865V24.176C57.4865 23.5402 57.1689 23.1825 56.5726 23.1825C56.3343 23.1825 56.0561 23.262 55.8574 23.3812C55.6192 23.5402 55.4598 23.6992 55.301 23.8978V28.0705H53.6719V21.9108H55.301V22.7056C55.4598 22.4672 55.738 22.2685 56.0961 22.0698C56.4932 21.8711 56.8907 21.752 57.2882 21.752C58.1623 21.752 58.7585 22.1096 58.9968 22.8646C59.1956 22.5466 59.4738 22.3083 59.8713 22.0698C60.2683 21.8314 60.6659 21.752 61.1029 21.752C61.6992 21.752 62.1362 21.9109 62.4543 22.2288C62.772 22.5466 62.9308 23.0236 62.9308 23.6196V28.0705Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M68.0576 28.2293C67.3023 28.2293 66.6667 27.9114 66.1503 27.2755V30.4149H64.5205V21.9108H66.1503V22.7055C66.6268 22.0697 67.263 21.7915 68.0576 21.7915C68.8522 21.7915 69.5277 22.0697 70.0442 22.6658C70.5612 23.2619 70.7995 24.017 70.7995 25.0502C70.7995 26.0436 70.5612 26.8384 70.0442 27.4345C69.5277 27.9114 68.8522 28.2293 68.0576 28.2293ZM67.5412 26.7589C68.0177 26.7589 68.3757 26.6 68.6539 26.2423C68.9314 25.9244 69.0905 25.4873 69.0905 24.931C69.0905 24.4143 68.9314 23.9772 68.6539 23.6593C68.3757 23.3413 67.9778 23.1824 67.5412 23.1824C67.263 23.1824 67.0241 23.2619 66.7459 23.3811C66.4677 23.5003 66.2687 23.699 66.1503 23.8977V26.0834C66.2687 26.282 66.5076 26.441 66.7459 26.5602C67.0241 26.7192 67.3023 26.7589 67.5412 26.7589Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M73.5813 28.0704H71.9521V19.5662H73.5813V28.0704Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M80.4956 28.0705H78.8665V27.4347C78.4292 27.9512 77.7537 28.2294 76.9192 28.2294C76.3628 28.2294 75.8857 28.0307 75.4484 27.673C75.0119 27.3154 74.7729 26.7988 74.7729 26.163C74.7729 25.4874 74.9719 25.0105 75.4085 24.6528C75.8464 24.335 76.3229 24.1363 76.9192 24.1363C77.793 24.1363 78.4292 24.3747 78.8665 24.8913V24.0965C78.8665 23.7786 78.7467 23.5402 78.5084 23.3414C78.2702 23.1428 77.9521 23.0633 77.5148 23.0633C76.8393 23.0633 76.2431 23.3018 75.7266 23.7786L75.1303 22.7056C75.8464 22.0698 76.7601 21.752 77.8329 21.752C78.6276 21.752 79.2638 21.9506 79.7802 22.3083C80.2967 22.666 80.5356 23.262 80.5356 24.0965V28.0705H80.4956ZM77.5947 27.1167C78.1903 27.1167 78.6276 26.9577 78.9057 26.6001V25.845C78.6276 25.4874 78.1903 25.3285 77.5947 25.3285C77.2766 25.3285 76.9984 25.4079 76.7601 25.5668C76.5212 25.7258 76.442 25.9643 76.442 26.2425C76.442 26.5206 76.5612 26.759 76.7601 26.918C76.9984 27.0372 77.2373 27.1167 77.5947 27.1167Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M84.1915 28.2293C83.6351 28.2293 83.1979 28.0703 82.8798 27.7921C82.5623 27.514 82.4432 27.0768 82.4432 26.5602V23.3016H81.4097V21.871H82.4432V20.2019H84.0724V21.871H85.3042V23.3016H84.0724V26.0833C84.0724 26.282 84.1123 26.441 84.2314 26.5602C84.3505 26.6794 84.4697 26.7589 84.6287 26.7589C84.867 26.7589 85.066 26.6794 85.1851 26.5602L85.5425 27.7921C85.225 28.0703 84.7878 28.2293 84.1915 28.2293Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M89.3179 28.2293C88.3642 28.2293 87.5696 27.9114 86.9733 27.355C86.3377 26.7589 86.0596 25.9642 86.0596 25.0104C86.0596 24.0964 86.377 23.3413 86.9733 22.7055C87.5696 22.0697 88.3243 21.7915 89.278 21.7915C90.1924 21.7915 90.9471 22.1095 91.5034 22.7453C92.0598 23.3811 92.338 24.1759 92.338 25.2091V25.5667H87.7679C87.8079 25.9642 88.0068 26.3218 88.3243 26.6C88.6424 26.8782 89.0397 26.9974 89.5561 26.9974C89.8343 26.9974 90.1125 26.9576 90.4306 26.8384C90.7487 26.7192 90.987 26.5602 91.1853 26.4013L91.9014 27.4345C91.2252 27.9511 90.3907 28.2293 89.3179 28.2293ZM90.7487 24.4143C90.7088 24.0567 90.5897 23.7388 90.3508 23.4606C90.1125 23.1824 89.7152 23.0235 89.238 23.0235C88.7615 23.0235 88.4035 23.1427 88.1652 23.4209C87.927 23.699 87.7679 24.017 87.7287 24.3745H90.7487V24.4143Z',
				fill: 'currentColor',
			},
		),
		el(
			'path',
			{
				d: 'M95.7159 28.2293C95.1995 28.2293 94.6824 28.1498 94.1659 27.9908C93.6888 27.8319 93.2522 27.5935 92.9341 27.2755L93.6495 26.1231C93.8878 26.3615 94.2059 26.5205 94.6032 26.7192C95.0005 26.8782 95.3978 26.9576 95.7558 26.9576C96.1132 26.9576 96.3515 26.9179 96.5105 26.7987C96.6696 26.6795 96.7887 26.5205 96.7887 26.3218C96.7887 26.1628 96.7088 26.0436 96.5105 25.9642C96.3122 25.8847 96.1132 25.8052 95.835 25.7654C95.5569 25.7257 95.2787 25.6462 94.9606 25.5667C94.6431 25.4873 94.3649 25.3681 94.0867 25.2488C93.8086 25.1296 93.6096 24.9309 93.4106 24.6925C93.2123 24.4143 93.1324 24.0964 93.1324 23.7388C93.1324 23.1824 93.3713 22.7453 93.8086 22.3479C94.2451 21.9902 94.8814 21.7915 95.676 21.7915C96.6296 21.7915 97.4642 22.0697 98.1796 22.626L97.5434 23.7388C97.3451 23.5401 97.1068 23.3811 96.7488 23.2221C96.4313 23.103 96.0733 23.0235 95.7159 23.0235C95.4377 23.0235 95.1995 23.0632 95.0005 23.1824C94.8015 23.3016 94.7223 23.4606 94.7223 23.6195C94.7223 23.7388 94.8015 23.858 95.0005 23.9772C95.1595 24.0567 95.3978 24.1362 95.676 24.1759C95.9542 24.2156 96.2323 24.2951 96.5505 24.3745C96.8686 24.4541 97.1467 24.5733 97.4249 24.6925C97.7031 24.8117 97.9414 25.0104 98.0998 25.2885C98.2595 25.5667 98.3779 25.8847 98.3779 26.282C98.3779 26.8782 98.1397 27.3153 97.6632 27.7127C97.186 28.0306 96.5105 28.2293 95.7159 28.2293Z',
				fill: 'currentColor',
			},
		),
	),
	el(
		'defs',
		null,
		el(
			'clipPath',
			{
				id: 'clip_spec_ai_starter_templates_logo',
			},
			el(
				'rect',
				{
					width: 98.1818,
					height: 36,
					fill: 'white',
					transform: 'translate(0.540527)',
				},
			),
		),
	),
);

// Logo: Presto Player.
export const PrestoPlayerLogo = el(
	'svg',
	{
		width: 197,
		height: 32,
		viewBox: '0 0 197 32',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'g',
		{
			clipPath: 'url(#clip_spec_ai_presto_player_logo)',
		},
		el(
			'mask',
			{
				id: 'mask_spec_ai_presto_player_logo',
				style: { maskType: 'luminance' },
				maskUnits: 'userSpaceOnUse',
				x: 0,
				y: 0,
				width: 197,
				height: 32,
			},
			el(
				'path',
				{
					d: 'M196.266 0H0.909668V31.3308H196.266V0Z',
					fill: 'white',
				},
			),
		),
		el(
			'g',
			{
				mask: 'url(#mask_spec_ai_presto_player_logo)',
			},
			el(
				'path',
				{
					fillRule: 'evenodd',
					clipRule: 'evenodd',
					d: 'M55.0934 18.8195C55.0934 21.6678 52.7897 23.689 49.4723 23.689C46.9842 23.689 44.8649 22.5866 43.7592 20.749L46.4315 18.452C47.1686 19.6465 48.4588 20.2896 49.6567 20.2896C50.8545 20.2896 51.5919 19.7384 51.5919 19.0033C51.5919 18.2682 50.9468 17.717 49.3803 17.1657L48.2743 16.7981C45.6941 15.9713 44.312 14.4093 44.312 12.2961C44.312 9.17221 46.6156 7.42651 49.7489 7.42651C51.684 7.42651 53.3426 8.06968 54.8169 9.63166L52.5132 12.0205C51.7761 11.1936 50.7624 10.7341 49.7489 10.7341C48.7352 10.7341 47.8137 11.1017 47.8137 11.9286C47.8137 12.7555 48.5508 13.2149 50.2095 13.7661L51.3154 14.1337C53.6191 14.9606 55.0934 16.4306 55.0934 18.8195ZM6.25433 7.61025C9.38743 7.61025 11.7833 9.99915 11.7833 13.0312C11.7833 16.0632 9.38743 18.452 6.25433 18.3601H4.41135V23.3217H0.909668V7.61025H6.25433ZM6.16217 15.0525C7.45228 15.0525 8.37376 14.2255 8.37376 13.0312C8.37376 11.9286 7.45228 11.0098 6.16217 10.9179H4.41135V15.0525H6.16217ZM18.6945 23.4136H15.1928V7.70213H21.3668C24.3156 7.70213 26.2508 9.90728 26.2508 12.4798C26.2508 14.5012 25.2372 15.7875 23.2098 16.5225L28.7387 23.4136H24.4998L19.2474 16.89H18.6945V23.4136ZM18.6945 10.9179V13.858H20.9982C22.0118 13.858 22.749 13.3068 22.749 12.388C22.749 11.4692 22.0118 10.9179 20.9982 10.9179H18.6945ZM30.9503 23.4136H40.9025V20.014H34.452V17.1656H39.6124V13.7661H34.452V10.9179H40.9025V7.70213H30.9503V23.4136ZM61.2674 23.4136H64.8612V11.0098H68.9159V7.70213H57.2129V11.1016H61.2674V23.4136ZM86.8848 15.6037C86.8848 20.0139 83.2912 23.689 78.7758 23.689C74.2605 23.689 70.6667 20.0139 70.6667 15.6037C70.6667 11.1935 74.2605 7.51837 78.7758 7.51837C83.1991 7.51837 86.8848 11.1016 86.8848 15.6037ZM74.1684 15.6037C74.1684 18.0845 76.1957 20.2896 78.7758 20.2896C81.356 20.2896 83.3833 18.0845 83.3833 15.6037C83.3833 13.1229 81.356 10.9179 78.7758 10.9179C76.1957 10.9179 74.1684 13.1229 74.1684 15.6037Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					fillRule: 'evenodd',
					clipRule: 'evenodd',
					d: 'M148.072 21.644H146.137V5.10571H148.072V21.644ZM134.066 26.3299H132.13V10.5266H134.066V12.2723C134.802 11.1697 136.277 10.3428 137.936 10.3428C140.977 10.3428 143.372 13.0073 143.372 16.1312C143.372 19.347 140.977 21.9196 137.936 21.9196C136.277 21.9196 134.802 21.0927 134.066 19.9901V26.3299ZM137.659 20.1738C139.871 20.1738 141.437 18.3363 141.437 16.1312C141.437 13.9261 139.871 12.1804 137.659 12.0885C135.447 12.0885 133.881 13.9261 133.881 16.1312C133.881 18.4281 135.447 20.1738 137.659 20.1738ZM150.744 16.1312C150.744 19.2551 153.048 21.9196 156.181 21.9196C157.84 21.9196 159.314 21.0927 160.051 19.9901V21.7359H161.986V10.7103H160.051V12.456C159.314 11.3535 157.84 10.5266 156.181 10.5266C153.14 10.4347 150.744 13.0073 150.744 16.1312ZM160.236 16.1312C160.236 18.3363 158.669 20.1738 156.458 20.1738C154.246 20.1738 152.679 18.4281 152.679 16.1312C152.679 13.9261 154.246 12.0885 156.458 12.0885C158.761 12.1804 160.236 13.9261 160.236 16.1312ZM175.809 10.6185L168.53 26.3299H166.502L168.898 21.0927L164.014 10.6185H166.134L169.911 18.9795L173.69 10.6185H175.809ZM176.638 16.1312C176.638 19.347 178.942 21.9196 182.352 21.9196C184.655 21.9196 186.314 20.9089 187.328 19.2551L185.853 18.2445C185.208 19.4388 184.103 20.1739 182.352 20.1739C180.14 20.1739 178.573 18.612 178.482 16.5906H187.604V16.0393C187.604 12.456 185.208 10.5266 182.352 10.5266C179.034 10.4347 176.638 12.9155 176.638 16.1312ZM182.352 12.0885C184.01 12.0885 185.484 13.1911 185.762 15.0287H178.758C179.034 13.1911 180.693 12.0885 182.352 12.0885ZM192.304 21.644H190.369V10.7103H192.304V12.8235C192.764 11.3535 194.147 10.5266 195.436 10.5266C195.714 10.5266 195.99 10.5266 196.266 10.6185V12.5479C195.898 12.3641 195.621 12.3641 195.253 12.3641C193.87 12.3641 192.304 13.5586 192.304 16.1312V21.644Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 5.10571L122.6 10.4436L113.741 15.5493V5.10571Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M95.5576 5.10571L104.65 10.4436L95.5576 15.5493V5.10571Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 15.5495L122.6 10.4436V20.8872L113.741 15.5495Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 5.10571V15.5493L104.65 10.4436L113.741 5.10571Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 5.10576L104.65 10.4436V0L113.741 5.10576Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M104.65 10.4436V20.8872L95.5576 15.5494L104.65 10.4436Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M104.65 0V10.4436L95.5576 5.10576L104.65 0Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M104.65 20.8872V31.3308L95.5576 25.993L104.65 20.8872Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 15.5493L122.6 20.8872L113.741 25.9929V15.5493Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M95.5576 15.5493L104.65 20.8872L95.5576 25.9929V15.5493Z',
					fill: 'currentColor',
				},
			),
			el(
				'path',
				{
					d: 'M113.741 15.5493V25.9929L104.65 20.8872L113.741 15.5493Z',
					fill: 'currentColor',
				},
			),
		),
	),
	el(
		'defs',
		null,
		el(
			'clipPath',
			{
				id: 'clip_spec_ai_presto_player_logo',
			},
			el(
				'rect',
				{
					width: 196.211,
					height: 32,
					fill: 'white',
					transform: 'translate(0.508301)',
				},
			),
		),
	),
);

// Logo: Project Huddle.
export const ProjectHuddleLogo = el(
	'svg',
	{
		width: 222,
		height: 26,
		viewBox: '0 0 222 26',
		fill: 'none',
		xmlns: 'http://www.w3.org/2000/svg',
	},
	el(
		'path',
		{
			d: 'M48.7549 16.1218C48.7549 16.2809 48.8854 16.4228 49.0645 16.4228H50.5643C50.7278 16.4228 50.8739 16.2809 50.8739 16.1218V12.4058H52.9113C54.9001 12.4058 56.5454 10.8087 56.5454 8.84743C56.5454 6.93404 54.8995 5.35254 52.8952 5.35254H49.0647C48.8852 5.35254 48.7551 5.49468 48.7551 5.65295L48.7549 16.1218ZM50.8731 10.4769V7.29817H52.7644C53.6768 7.29817 54.4424 7.96268 54.4424 8.8319C54.4424 9.76537 53.6763 10.4771 52.7644 10.4771L50.8731 10.4769Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M61.6597 16.1216C61.6597 16.2807 61.7901 16.4226 61.9693 16.4226H63.4691C63.6326 16.4226 63.7787 16.2807 63.7787 16.1216V12.0897H65.5872L67.7548 16.2807C67.787 16.3432 67.8687 16.4226 68.0152 16.4226H69.7269C70.004 16.4226 70.1183 16.1696 70.004 15.9639L67.7712 11.9469C69.1891 11.3936 70.1833 10.2067 70.1833 8.75264C70.1833 6.87031 68.586 5.35254 66.6307 5.35254H61.9695C61.7904 5.35254 61.6599 5.49468 61.6599 5.65296L61.6597 16.1216ZM63.7949 10.3973V7.25018H66.4516C67.3149 7.25018 68.065 7.94575 68.065 8.78391C68.065 9.66941 67.3149 10.3967 66.4516 10.3967L63.7949 10.3973Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M74.959 10.9035C74.959 14.0659 77.5501 16.5805 80.8097 16.5805C84.0699 16.5805 86.6775 14.0665 86.6775 10.9035C86.6775 7.74073 84.0699 5.19409 80.8097 5.19409C77.5501 5.19409 74.959 7.74073 74.959 10.9035ZM77.0773 10.9035C77.0773 8.91094 78.7564 7.25042 80.8097 7.25042C82.863 7.25042 84.5585 8.91094 84.5585 10.9035C84.5585 12.8959 82.863 14.5256 80.8097 14.5256C78.7564 14.5256 77.0773 12.8959 77.0773 10.9035Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M90.0697 15.4263C90.3475 15.7581 91.1289 16.5805 92.5472 16.5805C94.4541 16.5805 95.9696 15.3155 95.9696 13.1169V5.65295C95.9696 5.49468 95.839 5.35254 95.6604 5.35254H94.1284C93.9485 5.35254 93.8185 5.49468 93.8185 5.65295V13.1172C93.8185 14.2086 93.15 14.7145 92.5151 14.7145C91.9773 14.7145 91.6502 14.4294 91.4388 14.2086C91.2924 14.0657 91.1289 14.035 90.9503 14.1925L90.1019 15.0317C90.0047 15.1418 89.9883 15.2994 90.0697 15.4263Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M101.885 16.1216C101.885 16.2807 102.016 16.4226 102.195 16.4226H108.828C109.007 16.4226 109.139 16.2807 109.139 16.1216V14.8252C109.139 14.6672 109.007 14.5254 108.828 14.5254H104.004V11.7578H108.029C108.192 11.7578 108.339 11.6313 108.339 11.4573V10.1448C108.339 9.98655 108.192 9.84444 108.029 9.84444H104.004V7.25121H108.828C109.007 7.25121 109.139 7.10821 109.139 6.95077V5.65296C109.139 5.49468 109.007 5.35254 108.828 5.35254H102.195C102.016 5.35254 101.885 5.49468 101.885 5.65296V16.1216Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M113.848 10.9033C113.848 14.0658 116.47 16.5803 119.73 16.5803C121.182 16.5803 122.583 16.0902 123.692 15.0478C123.806 14.9367 123.838 14.732 123.708 14.6206L122.697 13.6073C122.599 13.5123 122.419 13.4977 122.289 13.6073C121.604 14.1452 120.772 14.5099 119.795 14.5099C117.708 14.5099 116.144 12.8332 116.144 10.8563C116.144 8.86377 117.692 7.17158 119.779 7.17158C120.691 7.17158 121.604 7.51936 122.289 8.10443C122.418 8.23169 122.582 8.23169 122.696 8.10443L123.691 7.10822C123.822 6.98143 123.822 6.79211 123.675 6.6649C122.567 5.69996 121.377 5.19409 119.73 5.19409C116.471 5.19389 113.848 7.7405 113.848 10.9033Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M130.611 16.1218C130.611 16.2809 130.758 16.4228 130.922 16.4228H132.437C132.599 16.4228 132.747 16.2809 132.747 16.1218V7.25035H135.239C135.419 7.25035 135.55 7.10762 135.55 6.94957V5.65295C135.55 5.49468 135.419 5.35254 135.239 5.35254H128.118C127.939 5.35254 127.808 5.49468 127.808 5.65295V6.94957C127.808 7.10742 127.939 7.25035 128.118 7.25035H130.611V16.1218Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M140.505 16.1218C140.505 16.2809 140.651 16.4228 140.816 16.4228H142.331C142.51 16.4228 142.64 16.2809 142.64 16.1218V11.7579H147.955V16.1218C147.955 16.2809 148.085 16.4228 148.264 16.4228H149.764C149.926 16.4228 150.074 16.2809 150.074 16.1218V5.65295C150.074 5.49468 149.926 5.35254 149.764 5.35254H148.264C148.085 5.35254 147.955 5.49468 147.955 5.65295V9.84378H142.64V5.65295C142.64 5.49468 142.51 5.35254 142.331 5.35254H140.816C140.651 5.35254 140.505 5.49468 140.505 5.65295V16.1218Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M156.127 12.2317C156.127 14.6359 158.1 16.5803 160.658 16.5803C163.232 16.5803 165.204 14.6351 165.204 12.2317V5.65295C165.204 5.49468 165.058 5.35254 164.894 5.35254H163.347C163.168 5.35254 163.036 5.49468 163.036 5.65295V12.1366C163.036 13.4649 162.075 14.5244 160.658 14.5244C159.241 14.5244 158.295 13.4649 158.295 12.1203V5.65295C158.295 5.49468 158.164 5.35254 157.986 5.35254H156.437C156.274 5.35254 156.127 5.49468 156.127 5.65295V12.2317Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M171.264 16.1218C171.264 16.2809 171.394 16.4228 171.556 16.4228H175.419C178.565 16.4228 181.141 13.9403 181.141 10.8722C181.141 7.83623 178.565 5.35352 175.419 5.35352H171.556C171.394 5.35352 171.264 5.49566 171.264 5.65373V16.1218ZM173.366 14.4937V7.26608H175.223C177.343 7.26608 178.89 8.81615 178.89 10.8715C178.89 12.943 177.343 14.4937 175.223 14.4937H173.366Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M186.556 16.1218C186.556 16.2809 186.686 16.4228 186.849 16.4228H190.711C193.857 16.4228 196.433 13.9403 196.433 10.8722C196.433 7.83623 193.856 5.35352 190.711 5.35352H186.849C186.685 5.35352 186.556 5.49566 186.556 5.65373V16.1218ZM188.658 14.4937V7.26608H190.515C192.634 7.26608 194.183 8.81615 194.183 10.8715C194.183 12.943 192.634 14.4937 190.515 14.4937H188.658Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M201.847 16.1218C201.847 16.2809 201.977 16.4228 202.157 16.4228H208.123C208.301 16.4228 208.432 16.2809 208.432 16.1218V14.8254C208.432 14.6673 208.301 14.5256 208.123 14.5256H203.967V5.65295C203.967 5.49468 203.819 5.35254 203.657 5.35254H202.157C201.977 5.35254 201.847 5.49468 201.847 5.65295V16.1218Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M213.336 16.1216C213.336 16.2807 213.466 16.4226 213.646 16.4226H220.278C220.458 16.4226 220.59 16.2807 220.59 16.1216V14.8252C220.59 14.6672 220.458 14.5254 220.278 14.5254H215.455V11.7578H219.479C219.644 11.7578 219.791 11.6313 219.791 11.4573V10.1448C219.791 9.98655 219.644 9.84444 219.479 9.84444H215.455V7.25121H220.278C220.458 7.25121 220.59 7.10821 220.59 6.95077V5.65296C220.59 5.49468 220.458 5.35254 220.278 5.35254H213.646C213.466 5.35254 213.336 5.49468 213.336 5.65296V16.1216Z',
			fill: 'currentColor',
		},
	),
	el(
		'path',
		{
			d: 'M26.958 0H4.89329C2.86293 0 1.21582 1.59822 1.21582 3.56833V12.7024V12.707V24.0263C1.21582 25.2068 2.60872 25.8773 3.57773 25.1622L8.65999 21.4098H26.9584C28.9899 21.4098 30.6359 19.8125 30.6359 17.8414V3.56812C30.6355 1.59822 28.9897 0 26.958 0ZM24.6105 10.5282C23.0424 13.642 19.7447 15.7915 15.9257 15.7915C12.1072 15.7915 8.80894 13.642 7.24124 10.5282C6.88425 9.82006 7.18647 8.96521 7.91707 8.61921C8.64644 8.27279 9.52784 8.56707 9.88445 9.27495C10.9784 11.4466 13.2736 12.9366 15.9257 12.9366C18.5783 12.9366 20.8734 11.4462 21.9673 9.27495C22.3237 8.56686 23.2051 8.27279 23.9346 8.61921C24.6651 8.96521 24.9673 9.81924 24.6105 10.5282Z',
			fill: 'currentColor',
		},
	),
);
